<div class="d-table w-100 card-header less-padding" [ngClass]="cssClass" (click)="collapse(true)">
  <div class="d-table-row">
    <div class="d-table-cell">
      <ng-content></ng-content>
    </div>
    <div *ngIf="collapseOnClickHeader!=null" class="d-table-cell header-button text-end">
      <div class="collapse-button" [ngClass]="{'is-collapsed': collapsed}" (click)="collapse(false)"><i class="fas fa-chevron-up"></i></div>
    </div>
  </div>
</div>